import React from "react";
import PropTypes from "prop-types";

import TakeoverPanel from "components/library/TakeoverPanel";
import TakeoverHeader from "components/library/TakeoverHeader";
import Button from "components/library/Button";
import LinkButton from "components/library/LinkButton";
import Dropdown from "components/library/Dropdown";
import Label from "components/library/Label";

import styles from "./MergeTagsSelection.css";

export default function MergeTagsSelection({
  tags,
  selectedTag,
  onChange,
  error,
  onClick,
}) {
  return (
    <TakeoverPanel>
      <TakeoverHeader>Merge {tags.length} tags</TakeoverHeader>
      <p className={styles.info}>
        This action will combine{" "}
        {tags.map((tag, i, tags) => {
          const separator = i
            ? i === tags.length - 1
              ? tags.length > 2
                ? ", and "
                : " and "
              : ", "
            : "";
          return (
            <React.Fragment key={i}>
              {separator} <span className={styles.name}>{tag.name}</span>
            </React.Fragment>
          );
        })}{" "}
        into one tag
      </p>
      <Label htmlFor="mergeTags">Merge tags into</Label>
      <Dropdown
        inputId="mergeTags"
        value={selectedTag}
        options={tags.map(tag => ({
          value: tag.id,
          name: tag.name,
        }))}
        placeholder="Select one of the tags"
        onChange={onChange}
        error={error}
      />

      <Button type="submit" onClick={onClick} className={styles.apply}>
        Choose this tag
      </Button>
      <LinkButton to="/settings/tags" type="cancel">
        No, cancel
      </LinkButton>
    </TakeoverPanel>
  );
}

MergeTagsSelection.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedTag: PropTypes.shape({
    value: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};
